/* Autogenerated file. Do not edit manually */
/* eslint-disable */
/* @ts-nocheck */

import { BaseOpenapiClient, type string } from 'foca-openapi';

export namespace OpenapiClientPump {
  export type GetTokenCoinsOwnedQuery = { page?: number; pageSize?: number; owner: string };
  export type GetTokenCoinsOwnedResponse = {
    page: number;
    pageSize: number;
    total: number;
    data: {
      balance: string;
      volume_sui: string;
      token_address: string;
      token_metadata: {
        /**
         * Number of decimal places the coin uses.
         */
        decimals: number;
        /**
         * Description of the token
         */
        description: string;
        /**
         * URL for the token logo
         */
        iconUrl: string;
        /**
         * Object id for the CoinMetadata object
         */
        id: string;
        /**
         * Name for the token
         */
        name: string;
        /**
         * Symbol for the token
         */
        symbol: string;
      };
    }[];
  };
  export type GetTokenCoinsHoldersQuery = { tokenAddress: string };
  export type GetTokenCoinsHoldersResponse = {
    wallet_address: string;
    balance: string;
    percentage: number;
  }[];
  export type GetPoolsQuery = {
    /**
     * Token symbol, name or type
     */
    search?: string;
    sort?: 'latest_trade_at' | 'created_at' | 'volume' | 'market_cap';
    direction?: 'asc' | 'desc';
    completed?: boolean;
    creator?: string;
    page?: number;
    pageSize?: number;
  };
  export type GetPoolsResponse = {
    page: number;
    pageSize: number;
    total: number;
    data: {
      bonding_curve: string;
      created_by: string;
      description: string;
      name: string;
      pool_id: string;
      symbol: string;
      telegram: string;
      token_address: string;
      twitter: string;
      uri: string;
      real_sui_reserves: string;
      real_token_reserves: string;
      virtual_sui_reserves: string;
      virtual_token_reserves: string;
      remain_token_reserves: string;
      website: string;
      deployment_fee: string;
      token_supply: string;
      lp_type: 0 | 1;
      token_metadata: {
        /**
         * Number of decimal places the coin uses.
         */
        decimals: number;
        /**
         * Description of the token
         */
        description: string;
        /**
         * URL for the token logo
         */
        iconUrl: string;
        /**
         * Object id for the CoinMetadata object
         */
        id: string;
        /**
         * Name for the token
         */
        name: string;
        /**
         * Symbol for the token
         */
        symbol: string;
      };
      is_completed: boolean;
      token_price: number;
      token_price_usd: number;
      market_cap: string;
      market_cap_usd: string;
      volume_24h: string;
      volume_24h_usd: string;
      volume: string;
      volume_usd: string;
      clmm_pool_id?: string | null;
      king_at?: string.DateTime | null;
      completed_at?: string.DateTime | null;
      latest_trade_at?: string.DateTime;
      deployed_at: string.DateTime;
      change_24h: number;
      trade_count: number;
      holders_count: number;
      holders_balance: string;
      holders_percentage: number;
      creator_ns: string | null;
    }[];
    king: {
      bonding_curve: string;
      created_by: string;
      description: string;
      name: string;
      pool_id: string;
      symbol: string;
      telegram: string;
      token_address: string;
      twitter: string;
      uri: string;
      real_sui_reserves: string;
      real_token_reserves: string;
      virtual_sui_reserves: string;
      virtual_token_reserves: string;
      remain_token_reserves: string;
      website: string;
      deployment_fee: string;
      token_supply: string;
      lp_type: 0 | 1;
      token_metadata: {
        /**
         * Number of decimal places the coin uses.
         */
        decimals: number;
        /**
         * Description of the token
         */
        description: string;
        /**
         * URL for the token logo
         */
        iconUrl: string;
        /**
         * Object id for the CoinMetadata object
         */
        id: string;
        /**
         * Name for the token
         */
        name: string;
        /**
         * Symbol for the token
         */
        symbol: string;
      };
      is_completed: boolean;
      token_price: number;
      token_price_usd: number;
      market_cap: string;
      market_cap_usd: string;
      volume_24h: string;
      volume_24h_usd: string;
      volume: string;
      volume_usd: string;
      clmm_pool_id?: string | null;
      king_at?: string.DateTime | null;
      completed_at?: string.DateTime | null;
      latest_trade_at?: string.DateTime;
      deployed_at: string.DateTime;
      change_24h: number;
      trade_count: number;
      holders_count: number;
      holders_balance: string;
      holders_percentage: number;
      creator_ns: string | null;
    } | null;
    featured: {
      bonding_curve: string;
      created_by: string;
      description: string;
      name: string;
      pool_id: string;
      symbol: string;
      telegram: string;
      token_address: string;
      twitter: string;
      uri: string;
      real_sui_reserves: string;
      real_token_reserves: string;
      virtual_sui_reserves: string;
      virtual_token_reserves: string;
      remain_token_reserves: string;
      website: string;
      deployment_fee: string;
      token_supply: string;
      lp_type: 0 | 1;
      token_metadata: {
        /**
         * Number of decimal places the coin uses.
         */
        decimals: number;
        /**
         * Description of the token
         */
        description: string;
        /**
         * URL for the token logo
         */
        iconUrl: string;
        /**
         * Object id for the CoinMetadata object
         */
        id: string;
        /**
         * Name for the token
         */
        name: string;
        /**
         * Symbol for the token
         */
        symbol: string;
      };
      is_completed: boolean;
      token_price: number;
      token_price_usd: number;
      market_cap: string;
      market_cap_usd: string;
      volume_24h: string;
      volume_24h_usd: string;
      volume: string;
      volume_usd: string;
      clmm_pool_id?: string | null;
      king_at?: string.DateTime | null;
      completed_at?: string.DateTime | null;
      latest_trade_at?: string.DateTime;
      deployed_at: string.DateTime;
      change_24h: number;
      trade_count: number;
      holders_count: number;
      holders_balance: string;
      holders_percentage: number;
      creator_ns: string | null;
    } | null;
  };
  export type GetPoolsByTokenAddressParams = { tokenAddress: string };
  export type GetPoolsByTokenAddressResponse = {
    bonding_curve: string;
    created_by: string;
    description: string;
    name: string;
    pool_id: string;
    symbol: string;
    telegram: string;
    token_address: string;
    twitter: string;
    uri: string;
    real_sui_reserves: string;
    real_token_reserves: string;
    virtual_sui_reserves: string;
    virtual_token_reserves: string;
    remain_token_reserves: string;
    website: string;
    deployment_fee: string;
    token_supply: string;
    lp_type: 0 | 1;
    token_metadata: {
      /**
       * Number of decimal places the coin uses.
       */
      decimals: number;
      /**
       * Description of the token
       */
      description: string;
      /**
       * URL for the token logo
       */
      iconUrl: string;
      /**
       * Object id for the CoinMetadata object
       */
      id: string;
      /**
       * Name for the token
       */
      name: string;
      /**
       * Symbol for the token
       */
      symbol: string;
    };
    is_completed: boolean;
    token_price: number;
    token_price_usd: number;
    market_cap: string;
    market_cap_usd: string;
    volume_24h: string;
    volume_24h_usd: string;
    volume: string;
    volume_usd: string;
    clmm_pool_id?: string | null;
    king_at?: string.DateTime | null;
    completed_at?: string.DateTime | null;
    latest_trade_at?: string.DateTime;
    deployed_at: string.DateTime;
    change_24h: number;
    trade_count: number;
    holders_count: number;
    holders_balance: string;
    holders_percentage: number;
    creator_ns: string | null;
  };
  export type GetPreheatResponse = {
    id: number;
    user_address: string;
    name: string;
    symbol: string;
    uri: string;
    description: string;
    twitter: string;
    telegram: string;
    personal_telegram: string;
    website: string;
    lp_type: number;
    is_published: boolean;
    created_at: string.DateTime;
    updated_at: string.DateTime;
  };
  export type GetRankingsBoundingCurveQuery = { limit?: number };
  export type GetRankingsBoundingCurveResponse = {
    token_address: string;
    real_sui_reserves: string;
    market_cap_usd: string;
    token_metadata: {
      /**
       * Number of decimal places the coin uses.
       */
      decimals: number;
      /**
       * Description of the token
       */
      description: string;
      /**
       * URL for the token logo
       */
      iconUrl: string;
      /**
       * Object id for the CoinMetadata object
       */
      id: string;
      /**
       * Name for the token
       */
      name: string;
      /**
       * Symbol for the token
       */
      symbol: string;
    };
  }[];
  export type GetRankingsMarketCapQuery = { limit?: number };
  export type GetRankingsMarketCapResponse = {
    token_address: string;
    market_cap_usd: string;
    deployed_at: string.DateTime;
    change_24h: number;
    created_by: string;
    is_completed: boolean;
    token_metadata: {
      /**
       * Number of decimal places the coin uses.
       */
      decimals: number;
      /**
       * Description of the token
       */
      description: string;
      /**
       * URL for the token logo
       */
      iconUrl: string;
      /**
       * Object id for the CoinMetadata object
       */
      id: string;
      /**
       * Name for the token
       */
      name: string;
      /**
       * Symbol for the token
       */
      symbol: string;
    };
  }[];
  export type GetRankingsChangesQuery = { limit: number };
  export type GetRankingsChangesResponse = {
    token_address: string;
    change_24h: number;
    market_cap_usd: string;
    created_by: string;
    deployed_at: string.DateTime;
    token_metadata: {
      /**
       * Number of decimal places the coin uses.
       */
      decimals: number;
      /**
       * Description of the token
       */
      description: string;
      /**
       * URL for the token logo
       */
      iconUrl: string;
      /**
       * Object id for the CoinMetadata object
       */
      id: string;
      /**
       * Name for the token
       */
      name: string;
      /**
       * Symbol for the token
       */
      symbol: string;
    };
  }[];
  export type GetThreadListQuery = { tokenAddress: string; page?: number; pageSize?: number };
  export type GetThreadListResponse = {
    page: number;
    pageSize: number;
    total: number;
    data: {
      id: number;
      token_address: string;
      wallet_address: string;
      attach_image: string | null;
      content: string;
      created_at: string.DateTime;
    }[];
  };
  export type GetTradeOhlcQuery = {
    tokenAddress: string;
    step:
      | 'minute'
      | '5minute'
      | '15minute'
      | '30minute'
      | 'hour'
      | '4hour'
      | 'day'
      | 'week'
      | 'month'
      | 'year';
    start: string.DateTime;
    end: string.DateTime;
  };
  export type GetTradeOhlcResponse = {
    open: number;
    close: number;
    low: number;
    high: number;
    timestamp: number;
  }[];
  export type GetTradeLatestPriceQuery = { tokenAddress: string };
  export type GetTradeLatestPriceResponse = {
    price_sui: number;
    price_usd: number;
    is_buy: boolean;
  };
  export type GetTradeHistoryQuery = {
    /**
     * User address
     */
    address?: string;
    tokenAddress: string;
    isBuy?: boolean;
    page?: number;
    pageSize?: number;
  };
  export type GetTradeHistoryResponse = {
    page: number;
    pageSize: number;
    total: number;
    data: {
      sender: string;
      is_buy: boolean;
      sui_amount: string;
      token_amount: string;
      timestamp: string.DateTime;
      tx_digest: string;
      pool_id: string;
      token_address: string;
    }[];
  };
  export type GetTradeTopEventsQuery = { size?: number };
  export type GetTradeTopEventsResponse = (
    | {
        type: 'trade';
        sender: string;
        is_buy: boolean;
        sui_amount: string;
        token_amount: string;
        timestamp: string.DateTime;
        tx_digest: string;
        pool_id: string;
        token_address: string;
        token_metadata: {
          /**
           * Number of decimal places the coin uses.
           */
          decimals: number;
          /**
           * Description of the token
           */
          description: string;
          /**
           * URL for the token logo
           */
          iconUrl: string;
          /**
           * Object id for the CoinMetadata object
           */
          id: string;
          /**
           * Name for the token
           */
          name: string;
          /**
           * Symbol for the token
           */
          symbol: string;
        };
      }
    | {
        type: 'pool-created';
        tx_digest: string;
        pool_id: string;
        sender: string;
        timestamp: string.DateTime;
        token_address: string;
        token_metadata: {
          /**
           * Number of decimal places the coin uses.
           */
          decimals: number;
          /**
           * Description of the token
           */
          description: string;
          /**
           * URL for the token logo
           */
          iconUrl: string;
          /**
           * Object id for the CoinMetadata object
           */
          id: string;
          /**
           * Name for the token
           */
          name: string;
          /**
           * Symbol for the token
           */
          symbol: string;
        };
      }
    | {
        type: 'pool-completed';
        tx_digest: string;
        pool_id: string;
        sender: string;
        timestamp: string.DateTime;
        token_address: string;
        token_metadata: {
          /**
           * Number of decimal places the coin uses.
           */
          decimals: number;
          /**
           * Description of the token
           */
          description: string;
          /**
           * URL for the token logo
           */
          iconUrl: string;
          /**
           * Object id for the CoinMetadata object
           */
          id: string;
          /**
           * Name for the token
           */
          name: string;
          /**
           * Symbol for the token
           */
          symbol: string;
        };
      }
  )[];
  export type GetTradeClmmOhlcQuery = {
    clmmPoolId: string;
    step:
      | 'minute'
      | '5minute'
      | '15minute'
      | '30minute'
      | 'hour'
      | '4hour'
      | 'day'
      | 'week'
      | 'month'
      | 'year';
    start: string.DateTime;
    end: string.DateTime;
  };
  export type GetTradeClmmOhlcResponse = {
    open: number;
    close: number;
    low: number;
    high: number;
    timestamp: number;
  }[];
  export type GetWalletsByWalletNsParams = { wallet: string };
  export type GetWalletsByWalletNsResponse = { ns: string | null };
  export type PostFileIconBody = { file: Blob };
  export type PostFileIconResponse = { url: string.Uri };
  export type PostPassportNonceBody = { walletAddress: string };
  export type PostPassportAuthBody = { walletAddress: string; signature: string };
  export type PostPreheatBody = {
    name: string;
    symbol: string;
    uri?: string;
    description?: string;
    twitter?: string;
    telegram?: string;
    website?: string;
    lp_type: 0 | 1;
    personalTelegram: string;
  };
  export type PostThreadBody = { tokenAddress: string; content: string; file?: Blob };
  export type PostThreadResponse = {
    id: number;
    token_address: string;
    wallet_address: string;
    attach_image: string | null;
    content: string;
    created_at: string.DateTime;
  };
  export type PostWalletsNsBody = { wallets: string[] };
  export type PostWalletsNsResponse = {} & { [key: string]: string | null };
}

export class OpenapiClientPump<T extends object = object> extends BaseOpenapiClient<T> {
  readonly coin = {
    /**
     * @uri /token-coins/owned
     * @method GET
     */
    getTokenCoinsOwned: (
      opts: OpenapiClientPump_get_paths['/token-coins/owned']['request'] &
        BaseOpenapiClient.UserInputOpts<T>,
    ): Promise<OpenapiClientPump_get_paths['/token-coins/owned']['response']> => {
      return this.request('/token-coins/owned', 'get', opts);
    },

    /**
     * @uri /token-coins/holders
     * @method GET
     */
    getTokenCoinsHolders: (
      opts: OpenapiClientPump_get_paths['/token-coins/holders']['request'] &
        BaseOpenapiClient.UserInputOpts<T>,
    ): Promise<OpenapiClientPump_get_paths['/token-coins/holders']['response']> => {
      return this.request('/token-coins/holders', 'get', opts);
    },
  };
  readonly pool = {
    /**
     * @uri /pools
     * @method GET
     */
    getPools: (
      opts?: OpenapiClientPump_get_paths['/pools']['request'] & BaseOpenapiClient.UserInputOpts<T>,
    ): Promise<OpenapiClientPump_get_paths['/pools']['response']> => {
      return this.request('/pools', 'get', opts);
    },

    /**
     * @uri /pools/{tokenAddress}
     * @method GET
     */
    getPoolsByTokenAddress: (
      opts: OpenapiClientPump_get_paths['/pools/{tokenAddress}']['request'] &
        BaseOpenapiClient.UserInputOpts<T>,
    ): Promise<OpenapiClientPump_get_paths['/pools/{tokenAddress}']['response']> => {
      return this.request('/pools/{tokenAddress}', 'get', opts);
    },
  };
  readonly preheat = {
    /**
     * @uri /preheat
     * @method GET
     */
    getPreheat: (
      opts?: OpenapiClientPump_get_paths['/preheat']['request'] &
        BaseOpenapiClient.UserInputOpts<T>,
    ): Promise<OpenapiClientPump_get_paths['/preheat']['response']> => {
      return this.request('/preheat', 'get', opts);
    },

    /**
     * @uri /preheat
     * @method POST
     */
    postPreheat: (
      opts: OpenapiClientPump_post_paths['/preheat']['request'] &
        BaseOpenapiClient.UserInputOpts<T>,
    ): Promise<OpenapiClientPump_post_paths['/preheat']['response']> => {
      return this.request('/preheat', 'post', opts);
    },

    /**
     * @uri /preheat/publish
     * @method PATCH
     */
    patchPreheatPublish: (
      opts?: OpenapiClientPump_patch_paths['/preheat/publish']['request'] &
        BaseOpenapiClient.UserInputOpts<T>,
    ): Promise<OpenapiClientPump_patch_paths['/preheat/publish']['response']> => {
      return this.request('/preheat/publish', 'patch', opts);
    },
  };
  readonly ranking = {
    /**
     * @uri /rankings/bounding-curve
     * @method GET
     */
    getRankingsBoundingCurve: (
      opts?: OpenapiClientPump_get_paths['/rankings/bounding-curve']['request'] &
        BaseOpenapiClient.UserInputOpts<T>,
    ): Promise<OpenapiClientPump_get_paths['/rankings/bounding-curve']['response']> => {
      return this.request('/rankings/bounding-curve', 'get', opts);
    },

    /**
     * @uri /rankings/market-cap
     * @method GET
     */
    getRankingsMarketCap: (
      opts?: OpenapiClientPump_get_paths['/rankings/market-cap']['request'] &
        BaseOpenapiClient.UserInputOpts<T>,
    ): Promise<OpenapiClientPump_get_paths['/rankings/market-cap']['response']> => {
      return this.request('/rankings/market-cap', 'get', opts);
    },

    /**
     * @uri /rankings/changes
     * @method GET
     */
    getRankingsChanges: (
      opts: OpenapiClientPump_get_paths['/rankings/changes']['request'] &
        BaseOpenapiClient.UserInputOpts<T>,
    ): Promise<OpenapiClientPump_get_paths['/rankings/changes']['response']> => {
      return this.request('/rankings/changes', 'get', opts);
    },
  };
  readonly thread = {
    /**
     * @uri /thread/list
     * @method GET
     */
    getThreadList: (
      opts: OpenapiClientPump_get_paths['/thread/list']['request'] &
        BaseOpenapiClient.UserInputOpts<T>,
    ): Promise<OpenapiClientPump_get_paths['/thread/list']['response']> => {
      return this.request('/thread/list', 'get', opts);
    },

    /**
     * @uri /thread
     * @method POST
     */
    postThread: (
      opts: OpenapiClientPump_post_paths['/thread']['request'] & BaseOpenapiClient.UserInputOpts<T>,
    ): Promise<OpenapiClientPump_post_paths['/thread']['response']> => {
      return this.request('/thread', 'post', opts);
    },
  };
  readonly trade = {
    /**
     * @uri /trade/ohlc
     * @method GET
     */
    getTradeOhlc: (
      opts: OpenapiClientPump_get_paths['/trade/ohlc']['request'] &
        BaseOpenapiClient.UserInputOpts<T>,
    ): Promise<OpenapiClientPump_get_paths['/trade/ohlc']['response']> => {
      return this.request('/trade/ohlc', 'get', opts);
    },

    /**
     * @uri /trade/latest-price
     * @method GET
     */
    getTradeLatestPrice: (
      opts: OpenapiClientPump_get_paths['/trade/latest-price']['request'] &
        BaseOpenapiClient.UserInputOpts<T>,
    ): Promise<OpenapiClientPump_get_paths['/trade/latest-price']['response']> => {
      return this.request('/trade/latest-price', 'get', opts);
    },

    /**
     * @uri /trade/history
     * @method GET
     */
    getTradeHistory: (
      opts: OpenapiClientPump_get_paths['/trade/history']['request'] &
        BaseOpenapiClient.UserInputOpts<T>,
    ): Promise<OpenapiClientPump_get_paths['/trade/history']['response']> => {
      return this.request('/trade/history', 'get', opts);
    },

    /**
     * Get top events list
     * @uri /trade/top-events
     * @method GET
     */
    getTradeTopEvents: (
      opts?: OpenapiClientPump_get_paths['/trade/top-events']['request'] &
        BaseOpenapiClient.UserInputOpts<T>,
    ): Promise<OpenapiClientPump_get_paths['/trade/top-events']['response']> => {
      return this.request('/trade/top-events', 'get', opts);
    },

    /**
     * @uri /trade/clmm/ohlc
     * @method GET
     */
    getTradeClmmOhlc: (
      opts: OpenapiClientPump_get_paths['/trade/clmm/ohlc']['request'] &
        BaseOpenapiClient.UserInputOpts<T>,
    ): Promise<OpenapiClientPump_get_paths['/trade/clmm/ohlc']['response']> => {
      return this.request('/trade/clmm/ohlc', 'get', opts);
    },
  };
  readonly wallet = {
    /**
     * @uri /wallets/{wallet}/ns
     * @method GET
     */
    getWalletsByWalletNs: (
      opts: OpenapiClientPump_get_paths['/wallets/{wallet}/ns']['request'] &
        BaseOpenapiClient.UserInputOpts<T>,
    ): Promise<OpenapiClientPump_get_paths['/wallets/{wallet}/ns']['response']> => {
      return this.request('/wallets/{wallet}/ns', 'get', opts);
    },

    /**
     * @uri /wallets/ns
     * @method POST
     */
    postWalletsNs: (
      opts: OpenapiClientPump_post_paths['/wallets/ns']['request'] &
        BaseOpenapiClient.UserInputOpts<T>,
    ): Promise<OpenapiClientPump_post_paths['/wallets/ns']['response']> => {
      return this.request('/wallets/ns', 'post', opts);
    },
  };
  readonly file = {
    /**
     * @uri /file/icon
     * @method POST
     */
    postFileIcon: (
      opts: OpenapiClientPump_post_paths['/file/icon']['request'] &
        BaseOpenapiClient.UserInputOpts<T>,
    ): Promise<OpenapiClientPump_post_paths['/file/icon']['response']> => {
      return this.request('/file/icon', 'post', opts);
    },
  };
  readonly passport = {
    /**
     * @uri /passport/nonce
     * @method POST
     */
    postPassportNonce: (
      opts: OpenapiClientPump_post_paths['/passport/nonce']['request'] &
        BaseOpenapiClient.UserInputOpts<T>,
    ): Promise<OpenapiClientPump_post_paths['/passport/nonce']['response']> => {
      return this.request('/passport/nonce', 'post', opts);
    },

    /**
     * @uri /passport/auth
     * @method POST
     */
    postPassportAuth: (
      opts: OpenapiClientPump_post_paths['/passport/auth']['request'] &
        BaseOpenapiClient.UserInputOpts<T>,
    ): Promise<OpenapiClientPump_post_paths['/passport/auth']['response']> => {
      return this.request('/passport/auth', 'post', opts);
    },
  };

  protected override pickContentTypes(uri: string, method: string) {
    return contentTypes[method + ' ' + uri] || [void 0, void 0];
  }
}

interface OpenapiClientPump_get_paths {
  '/token-coins/owned': BaseOpenapiClient.Prettify<{
    request: {
      query: OpenapiClientPump.GetTokenCoinsOwnedQuery;
    };
    response: OpenapiClientPump.GetTokenCoinsOwnedResponse;
  }>;
  '/token-coins/holders': BaseOpenapiClient.Prettify<{
    request: {
      query: OpenapiClientPump.GetTokenCoinsHoldersQuery;
    };
    response: OpenapiClientPump.GetTokenCoinsHoldersResponse;
  }>;
  '/pools': BaseOpenapiClient.Prettify<{
    request: {
      query?: OpenapiClientPump.GetPoolsQuery;
    };
    response: OpenapiClientPump.GetPoolsResponse;
  }>;
  '/pools/{tokenAddress}': BaseOpenapiClient.Prettify<{
    request: {
      query?: object;
      params: OpenapiClientPump.GetPoolsByTokenAddressParams;
    };
    response: OpenapiClientPump.GetPoolsByTokenAddressResponse;
  }>;
  '/preheat': BaseOpenapiClient.Prettify<{
    request: {
      query?: object;
    };
    response: OpenapiClientPump.GetPreheatResponse;
  }>;
  '/rankings/bounding-curve': BaseOpenapiClient.Prettify<{
    request: {
      query?: OpenapiClientPump.GetRankingsBoundingCurveQuery;
    };
    response: OpenapiClientPump.GetRankingsBoundingCurveResponse;
  }>;
  '/rankings/market-cap': BaseOpenapiClient.Prettify<{
    request: {
      query?: OpenapiClientPump.GetRankingsMarketCapQuery;
    };
    response: OpenapiClientPump.GetRankingsMarketCapResponse;
  }>;
  '/rankings/changes': BaseOpenapiClient.Prettify<{
    request: {
      query: OpenapiClientPump.GetRankingsChangesQuery;
    };
    response: OpenapiClientPump.GetRankingsChangesResponse;
  }>;
  '/thread/list': BaseOpenapiClient.Prettify<{
    request: {
      query: OpenapiClientPump.GetThreadListQuery;
    };
    response: OpenapiClientPump.GetThreadListResponse;
  }>;
  '/trade/ohlc': BaseOpenapiClient.Prettify<{
    request: {
      query: OpenapiClientPump.GetTradeOhlcQuery;
    };
    response: OpenapiClientPump.GetTradeOhlcResponse;
  }>;
  '/trade/latest-price': BaseOpenapiClient.Prettify<{
    request: {
      query: OpenapiClientPump.GetTradeLatestPriceQuery;
    };
    response: OpenapiClientPump.GetTradeLatestPriceResponse;
  }>;
  '/trade/history': BaseOpenapiClient.Prettify<{
    request: {
      query: OpenapiClientPump.GetTradeHistoryQuery;
    };
    response: OpenapiClientPump.GetTradeHistoryResponse;
  }>;
  '/trade/top-events': BaseOpenapiClient.Prettify<{
    request: {
      query?: OpenapiClientPump.GetTradeTopEventsQuery;
    };
    response: OpenapiClientPump.GetTradeTopEventsResponse;
  }>;
  '/trade/clmm/ohlc': BaseOpenapiClient.Prettify<{
    request: {
      query: OpenapiClientPump.GetTradeClmmOhlcQuery;
    };
    response: OpenapiClientPump.GetTradeClmmOhlcResponse;
  }>;
  '/wallets/{wallet}/ns': BaseOpenapiClient.Prettify<{
    request: {
      query?: object;
      params: OpenapiClientPump.GetWalletsByWalletNsParams;
    };
    response: OpenapiClientPump.GetWalletsByWalletNsResponse;
  }>;
}
interface OpenapiClientPump_post_paths {
  '/file/icon': BaseOpenapiClient.Prettify<{
    request: {
      query?: object;

      body: OpenapiClientPump.PostFileIconBody;
    };
    response: OpenapiClientPump.PostFileIconResponse;
  }>;
  '/passport/nonce': BaseOpenapiClient.Prettify<{
    request: {
      query?: object;

      body: OpenapiClientPump.PostPassportNonceBody;
    };
    response: unknown;
  }>;
  '/passport/auth': BaseOpenapiClient.Prettify<{
    request: {
      query?: object;

      body: OpenapiClientPump.PostPassportAuthBody;
    };
    response: unknown;
  }>;
  '/preheat': BaseOpenapiClient.Prettify<{
    request: {
      query?: object;

      body: OpenapiClientPump.PostPreheatBody;
    };
    response: unknown;
  }>;
  '/thread': BaseOpenapiClient.Prettify<{
    request: {
      query?: object;

      body: OpenapiClientPump.PostThreadBody;
    };
    response: OpenapiClientPump.PostThreadResponse;
  }>;
  '/wallets/ns': BaseOpenapiClient.Prettify<{
    request: {
      query?: object;

      body: OpenapiClientPump.PostWalletsNsBody;
    };
    response: OpenapiClientPump.PostWalletsNsResponse;
  }>;
}
interface OpenapiClientPump_patch_paths {
  '/preheat/publish': BaseOpenapiClient.Prettify<{
    request: {
      query?: object;
    };
    response: unknown;
  }>;
}

const contentTypes: Record<
  string,
  [
    BaseOpenapiClient.UserInputOpts['requestBodyType'],
    BaseOpenapiClient.UserInputOpts['responseType'],
  ]
> = {
  'post /file/icon': ['multipart/form-data', void 0],

  'post /thread': ['multipart/form-data', void 0],
};
